module.exports = __webpack_public_path__ + "img/security.cfaec6b8.svg";